export const IST_TIMEZONE = "Asia/Kolkata";

export const nowIST = () =>
  new Date(new Date().toLocaleString("en-US", { timeZone: IST_TIMEZONE }));

export const formatIST = (date: string | Date) =>
  new Date(date).toLocaleString("en-IN", {
    timeZone: IST_TIMEZONE,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

export const todayIST = () =>
  nowIST().toISOString().split("T")[0];

export const maxDateIST = (daysAhead: number) => {
  const now = new Date(
    new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );

  now.setDate(now.getDate() + daysAhead);

  return now.toISOString().split("T")[0];
};

export function formatDate(dateString: string) {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // convert "0" to "12"

  const formattedHours = String(hours).padStart(2, "0");

  return `${day}/${month}/${year} ${formattedHours}:${minutes} ${ampm}`;
}

// utils/dateUtil.ts

// Generate time options from 07:00 to 20:00 in 30-minute increments
export const generateTimeOptions = (): string[] => {
  const options: string[] = [];
  let hour = 7;
  let minute = 0;
  while (hour < 20 || (hour === 20 && minute === 0)) {
    const hStr = hour.toString().padStart(2, "0");
    const mStr = minute.toString().padStart(2, "0");
    options.push(`${hStr}:${mStr}`);
    minute += 30;
    if (minute === 60) {
      minute = 0;
      hour++;
    }
  }
  return options;
};

// End options at least 1 hour after start
export const getEndOptions = (start: string, timeOptions: string[]): string[] => {
  if (!start) return [];
  const [sh, sm] = start.split(":").map(Number);
  const startMinutes = sh * 60 + sm;
  const minEndMinutes = startMinutes + 60;
  return timeOptions.filter((t) => {
    const [eh, em] = t.split(":").map(Number);
    const endMinutes = eh * 60 + em;
    return endMinutes >= minEndMinutes;
  });
};

